import BaseService from './Base';

class ClientInstances extends BaseService {
  static endpoint = 'api/2.0/clientinstance/';
}

export default ClientInstances;